/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#161616";
export const ColorTextPrimaryInverted = "#FFFFFF";
export const ColorTextSecondary = "rgba(13,15,19,0.76)";
export const ColorTextSecondaryInverted = "rgba(255,255,255,0.6)";
export const ColorTextBrand = "#161616";
export const ColorTextBrandInverted = "#FFFFFF";
export const ColorTextDisabled = "rgba(19,29,60,0.4)";
export const ColorTextDisabledInverted = "rgba(255,255,255,0.4)";
export const ColorTextInactive = "rgba(19,29,60,0.4)";
export const ColorTextActive = "#161616";
export const ColorTextLink = "#161616";
export const ColorTextLinkInverted = "#FFFFFF";
export const ColorTextLinkHover = "rgba(14,24,54,0.5)";
export const ColorTextLinkHoverInverted = "rgba(255,255,255,0.5)";
export const ColorTextSale = "#D11616";
export const ColorTextSuccess = "#32852D";
export const ColorTextOnSuccessLight = "#275724";
export const ColorTextOnSuccess = "#FFFFFF";
export const ColorTextError = "#DA2828";
export const ColorTextOnErrorLight = "#981C1C";
export const ColorTextOnError = "#FFFFFF";
export const ColorTextWarning = "#AE600E";
export const ColorTextOnWarningLight = "#803A13";
export const ColorTextOnWarning = "#FFFFFF";
export const ColorTextInfo = "#6D6D6D";
export const ColorTextOnInfoLight = "#5D5D5D";
export const ColorTextOnInfo = "#FFFFFF";
export const ColorIconPrimary = "#161616";
export const ColorIconPrimaryInverted = "#FFFFFF";
export const ColorIconSecondary = "rgba(14,24,54,0.5)";
export const ColorIconSecondaryInverted = "rgba(255,255,255,0.5)";
export const ColorIconBrand = "#161616";
export const ColorIconBrandInverted = "#FFFFFF";
export const ColorIconDisabled = "rgba(33,47,87,0.3)";
export const ColorIconDisabledInverted = "rgba(255,255,255,0.3)";
export const ColorIconInactive = "rgba(0,0,0,0.4)";
export const ColorIconActive = "#161616";
export const ColorIconHover = "#161616";
export const ColorIconFocus = "#161616";
export const ColorIconSuccess = "#32852D";
export const ColorIconOnSuccessLight = "#275724";
export const ColorIconOnSuccess = "#FFFFFF";
export const ColorIconError = "#DA2828";
export const ColorIconOnErrorLight = "#981C1C";
export const ColorIconOnError = "#FFFFFF";
export const ColorIconWarning = "#AE600E";
export const ColorIconOnWarningLight = "#803A13";
export const ColorIconOnWarning = "#FFFFFF";
export const ColorIconInfo = "#878B99";
export const ColorIconOnInfoLight = "#676973";
export const ColorIconOnInfo = "#FFFFFF";
export const ColorIconFavorite = "#FF0000";
export const ColorBackgroundPrimary = "#FFFFFF";
export const ColorBackgroundSecondary = "#F7F8FB";
export const ColorBackgroundTertiary = "#EBECF5";
export const ColorBackgroundBrand = "#161616";
export const ColorBackgroundOverlay = "rgba(0,0,0,0.3)";
export const ColorBackgroundInactive = "#FFFFFF";
export const ColorBackgroundActive = "rgba(60,75,119,0.04)";
export const ColorBackgroundHover = "rgba(52,77,152,0.1)";
export const ColorBackgroundFocus = "rgba(52,77,152,0.1)";
export const ColorBackgroundPressed = "rgba(60,77,129,0.2)";
export const ColorBackgroundDisabled = "rgba(52,77,152,0.1)";
export const ColorBackgroundSuccess = "#32852D";
export const ColorBackgroundSuccessLight = "#C9ECC6";
export const ColorBackgroundError = "#DA2828";
export const ColorBackgroundErrorLight = "#FDCBCB";
export const ColorBackgroundWarning = "#AE600E";
export const ColorBackgroundWarningLight = "#F7E090";
export const ColorBackgroundInfo = "#EBECF5";
export const ColorBackgroundInfoLight = "#EBECF5";
export const ColorBorderPrimary = "rgba(19,29,60,0.4)";
export const ColorBorderPrimaryInverted = "rgba(255,255,255,0.4)";
export const ColorBorderSecondary = "rgba(60,77,129,0.2)";
export const ColorBorderSecondaryInverted = "rgba(255,255,255,0.2)";
export const ColorBorderTertiary = "rgba(52,77,152,0.1)";
export const ColorBorderTertiaryInverted = "rgba(255,255,255,0.1)";
export const ColorBorderBrand = "#161616";
export const ColorBorderFocus = "#161616";
export const ColorBorderHover = "#161616";
export const ColorBorderDisabled = "rgba(52,77,152,0.1)";
export const ColorBorderFocusRing = "#161616";
export const ColorBorderFocusRingInverted = "#FFFFFF";
export const ColorBorderSuccess = "#32852D";
export const ColorBorderWarning = "#AE600E";
export const ColorBorderError = "#DA2828";
export const ColorBorderInfo = "#878B99";
export const OutlineWidth = "2px";
export const OutlineOffset = "2px";
export const Spacing2 = "2px";
export const Spacing4 = "4px";
export const Spacing6 = "6px";
export const Spacing8 = "8px";
export const Spacing12 = "12px";
export const Spacing16 = "16px";
export const Spacing20 = "20px";
export const Spacing24 = "24px";
export const Spacing28 = "28px";
export const Spacing32 = "32px";
export const Spacing40 = "40px";
export const Spacing48 = "48px";
export const Spacing56 = "56px";
export const Spacing64 = "64px";
export const Spacing72 = "72px";
export const Spacing80 = "80px";
export const Spacing88 = "88px";
export const Spacing96 = "96px";
export const Spacing104 = "104px";
export const Spacing112 = "112px";
export const Spacing120 = "120px";
export const TypographyFamilyPrimary =
  '"Maison Neue", "Maison Neue Fallback Mac", "Maison Neue Fallback Win", "Maison Neue Fallback Android", sans-serif;';
export const TypographyFamilySecondary =
  '"Maison Neue", "Maison Neue Fallback Mac", "Maison Neue Fallback Win", "Maison Neue Fallback Android", sans-serif;';
export const TypographyHeadlineWeight = 500;
export const TypographyHeadlineSizeXxxl = "4rem";
export const TypographyHeadlineSizeXxl = "3.4285714285714284rem";
export const TypographyHeadlineSizeXl = "2.857142857142857rem";
export const TypographyHeadlineSizeLarge = "2.2857142857142856rem";
export const TypographyHeadlineSizeMedium = "2rem";
export const TypographyHeadlineSizeSmall = "1.7142857142857142rem";
export const TypographyHeadlineSizeXs = "1.4285714285714286rem";
export const TypographyHeadlineSizeXxs = "1.2857142857142858rem";
export const TypographyTitleWeight = 600;
export const TypographyTitleSizeXl = "1.7142857142857142rem";
export const TypographyTitleSizeLarge = "1.4285714285714286rem";
export const TypographyTitleSizeMedium = "1.2857142857142858rem";
export const TypographyTitleSizeSmall = "1.1428571428571428rem";
export const TypographyBodyWeightDefault = 400;
export const TypographyBodyWeightStrong = 700;
export const TypographyBodySizeLarge = "1.1428571428571428rem";
export const TypographyBodySizeMedium = "1rem";
export const TypographyBodySizeSmall = "0.8571428571428571rem";
export const TypographyLabelWeightDefault = 400;
export const TypographyLabelWeightStrong = 700;
export const TypographyLabelSizeLarge = "1.1428571428571428rem";
export const TypographyLabelSizeMedium = "1rem";
export const TypographyLabelSizeSmall = "0.8571428571428571rem";
export const TypographyLinkWeightDefault = 400;
export const TypographyLinkWeightStrong = 500;
export const TypographyLinkSizeLarge = "1.1428571428571428rem";
export const TypographyLinkSizeMedium = "1rem";
export const TypographyLinkSizeSmall = "0.8571428571428571rem";
export const RadiusSmall = "0px";
export const RadiusMedium = "0px";
export const RadiusLarge = "0px";
export const RadiusFull = "100vw";
export const ComponentsCtaRadiusSmall = "100vw";
export const ComponentsCtaRadiusMedium = "100vw";
export const ComponentsCtaRadiusLarge = "100vw";
export const ComponentsCtaPrimaryTextDefault = "#FFFFFF";
export const ComponentsCtaPrimaryIconDefault = "#FFFFFF";
export const ComponentsCtaPrimaryBgDefault = "#161616";
export const ComponentsCtaPrimaryBgHover = "#46484D";
export const ComponentsCtaPrimaryBgPressed = "#676973";
export const ComponentsCtaPrimaryBgFocused = "#46484D";
export const ComponentsCtaPrimaryBorderDefault = "transparent";
export const ComponentsCtaPrimaryBorderHover = "transparent";
export const ComponentsCtaPrimaryBorderPressed = "transparent";
export const ComponentsCtaPrimaryBorderFocus = "transparent";
export const ComponentsCtaPrimaryInvertedTextDefault = "#0E2B5D";
export const ComponentsCtaPrimaryInvertedIconDefault = "#0E2B5D";
export const ComponentsCtaPrimaryInvertedBgDefault = "#FFFFFF";
export const ComponentsCtaPrimaryInvertedBgHover = "rgba(255,255,255,0.9)";
export const ComponentsCtaPrimaryInvertedBgPressed = "rgba(255,255,255,0.9)";
export const ComponentsCtaPrimaryInvertedBgFocused = "rgba(255,255,255,0.6)";
export const ComponentsCtaPrimaryInvertedBorderDefault = "transparent";
export const ComponentsCtaPrimaryInvertedBorderHover = "transparent";
export const ComponentsCtaPrimaryInvertedBorderPressed = "transparent";
export const ComponentsCtaPrimaryInvertedBorderFocus = "transparent";
export const ComponentsCtaSecondaryTextDefault = "#161616";
export const ComponentsCtaSecondaryIconDefault = "#161616";
export const ComponentsCtaSecondaryBgDefault = "rgba(52,77,152,0.1)";
export const ComponentsCtaSecondaryBgHover = "rgba(60,77,129,0.2)";
export const ComponentsCtaSecondaryBgPressed = "rgba(33,47,87,0.3)";
export const ComponentsCtaSecondaryBgFocused = "rgba(60,77,129,0.2)";
export const ComponentsCtaSecondaryBorderDefault = "transparent";
export const ComponentsCtaSecondaryBorderHover = "transparent";
export const ComponentsCtaSecondaryBorderPressed = "transparent";
export const ComponentsCtaSecondaryBorderFocus = "transparent";
export const ComponentsCtaSecondaryInvertedTextDefault = "#FFFFFF";
export const ComponentsCtaSecondaryInvertedIconDefault = "#FFFFFF";
export const ComponentsCtaSecondaryInvertedBgDefault = "rgba(255,255,255,0.2)";
export const ComponentsCtaSecondaryInvertedBgHover = "rgba(255,255,255,0.3)";
export const ComponentsCtaSecondaryInvertedBgPressed = "rgba(255,255,255,0.4)";
export const ComponentsCtaSecondaryInvertedBgFocused = "rgba(255,255,255,0.3)";
export const ComponentsCtaSecondaryInvertedBorderDefault = "transparent";
export const ComponentsCtaSecondaryInvertedBorderHover = "transparent";
export const ComponentsCtaSecondaryInvertedBorderPressed = "transparent";
export const ComponentsCtaSecondaryInvertedBorderFocus = "transparent";
export const ComponentsCtaTertiaryTextDefault = "#161616";
export const ComponentsCtaTertiaryIconDefault = "#161616";
export const ComponentsCtaTertiaryBgDefault = "transparent";
export const ComponentsCtaTertiaryBgHover = "rgba(52,77,152,0.1)";
export const ComponentsCtaTertiaryBgPressed = "rgba(60,77,129,0.2)";
export const ComponentsCtaTertiaryBgFocused = "rgba(0,0,0,0.2)";
export const ComponentsCtaTertiaryBorderDefault = "#161616";
export const ComponentsCtaTertiaryBorderHover = "#161616";
export const ComponentsCtaTertiaryBorderPressed = "#161616";
export const ComponentsCtaTertiaryBorderFocus = "#161616";
export const ComponentsCtaTertiaryInvertedTextDefault = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedIconDefault = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedBgDefault = "transparent";
export const ComponentsCtaTertiaryInvertedBgHover = "rgba(255,255,255,0.1)";
export const ComponentsCtaTertiaryInvertedBgPressed = "rgba(255,255,255,0.1)";
export const ComponentsCtaTertiaryInvertedBgFocused = "rgba(255,255,255,0.4)";
export const ComponentsCtaTertiaryInvertedBorderDefault = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedBorderHover = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedBorderPressed = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedBorderFocus = "#FFFFFF";
export const ComponentsCtaGhostTextDefault = "#161616";
export const ComponentsCtaGhostIconDefault = "#161616";
export const ComponentsCtaGhostBgDefault = "transparent";
export const ComponentsCtaGhostBgHover = "rgba(52,77,152,0.1)";
export const ComponentsCtaGhostBgPressed = "rgba(60,77,129,0.2)";
export const ComponentsCtaGhostBgFocused = "rgba(52,77,152,0.1)";
export const ComponentsCtaGhostBorderDefault = "transparent";
export const ComponentsCtaGhostBorderHover = "transparent";
export const ComponentsCtaGhostBorderPressed = "transparent";
export const ComponentsCtaGhostBorderFocus = "transparent";
export const ComponentsCtaGhostInvertedTextDefault = "#FFFFFF";
export const ComponentsCtaGhostInvertedIconDefault = "#FFFFFF";
export const ComponentsCtaGhostInvertedBgDefault = "transparent";
export const ComponentsCtaGhostInvertedBgHover = "rgba(255,255,255,0.1)";
export const ComponentsCtaGhostInvertedBgPressed = "rgba(255,255,255,0.2)";
export const ComponentsCtaGhostInvertedBgFocused = "rgba(255,255,255,0.1)";
export const ComponentsCtaGhostInvertedBorderDefault = "transparent";
export const ComponentsCtaGhostInvertedBorderHover = "transparent";
export const ComponentsCtaGhostInvertedBorderPressed = "transparent";
export const ComponentsCtaGhostInvertedBorderFocus = "transparent";
export const ComponentsCtaInlineText = "#161616";
export const ComponentsCtaInlineBg = "transparent";
export const ComponentsCtaInlineTextHover = "rgba(15,20,35,0.64)";
export const ComponentsCtaInlineTextFocus = "#161616";
export const ComponentsCtaInlineTextPressed = "rgba(4,4,5,0.81)";
export const ComponentsCtaInlineTextDisabled = "rgba(19,29,60,0.4)";
export const ComponentsCtaInlineBorderFocus = "#161616";
export const ComponentsCtaInlineSecondaryText = "rgba(13,15,19,0.76)";
export const ComponentsCtaInlineSecondaryBg = "transparent";
export const ComponentsCtaInlineSecondaryTextHover = "rgba(4,4,5,0.81)";
export const ComponentsCtaInlineSecondaryTextFocus = "rgba(0,0,0,0.8)";
export const ComponentsCtaInlineSecondaryTextPressed = "rgba(4,5,7,0.88)";
export const ComponentsCtaInlineSecondaryTextDisabled = "rgba(19,29,60,0.4)";
export const ComponentsCtaInlineSecondaryBorderFocus = "#161616";
export const ComponentsCtaInlineInvertedText = "#FFFFFF";
export const ComponentsCtaInlineInvertedBg = "transparent";
export const ComponentsCtaInlineInvertedTextHover = "rgba(255,255,255,0.5)";
export const ComponentsCtaInlineInvertedTextFocus = "rgba(255,255,255,0.5)";
export const ComponentsCtaInlineInvertedTextPressed = "rgba(255,255,255,0.8)";
export const ComponentsCtaInlineInvertedTextDisabled = "rgba(255,255,255,0.4)";
export const ComponentsCtaInlineInvertedBorderFocus = "#FFFFFF";
export const ComponentsCtaNavigationText = "#161616";
export const ComponentsCtaNavigationBg = "#FFFFFF";
export const ComponentsCtaNavigationBgHover = "#D8DBE5";
export const ComponentsCtaNavigationBgFocus = "#D8DBE5";
export const ComponentsCtaNavigationBgPressed = "#BCC0CC";
export const ComponentsCtaDisabledTextDisabled = "rgba(19,29,60,0.4)";
export const ComponentsCtaDisabledIconDisabled = "rgba(33,47,87,0.3)";
export const ComponentsCtaDisabledBgDisabled = "rgba(52,77,152,0.1)";
export const ComponentsCtaDisabledBorderDisabled = "transparent";
export const ComponentsRatingActive = "#161616";
export const ComponentsRatingInactive = "rgba(33,47,87,0.3)";
export const ComponentsRatingStroke = "#161616";
export const ComponentsHeaderHeight = "120px";
export const ComponentsHeaderHeightDesktop = "72px";
export const ComponentsMenuBg = "#F7F8FB";
export const ComponentsMenuText = "#161616";
export const ComponentsMenuHeadline = "#606369";
export const ComponentsMenuDivider = "#D4D8E1";
export const ComponentsProductCardOverlay = "rgba(60,75,119,0.04)";
export const ComponentsLabelFixedPriceText = "#161616";
export const ComponentsLabelFixedPriceTextInverted = "#C73707";
export const ComponentsLabelFixedPriceBg = "#FF8937";
export const ComponentsLabelNewText = "#161616";
export const ComponentsLabelNewBg = "#76F96B";
export const AssetsFeaturedFooterMedicalPictogram =
  "/images/splashes/derma-badge-kicks.svg";
export const AssetsStarIconUrl =
  "/images/icons/design-system/kicks/24px/StarFilled.svg";
